export default __webpack_public_path__ + "static/media/photo1.707e98a6.jpg";